import {
  getCenterPersonList,
  addCenterPerson,
  postNewCenterPerson,
  updateCenterPerson,
  deleteCenterPerson,
  getCenterPersonTypeList,
  getCenterPersonDistinctionList,
  getUserListNotTeacher,
} from "@/services/center-person.service";
import { setPaginationDetails } from "@/utils/utils";

// initial state
const state = () => ({
  centerPersonModel: {
    editState: false,
    isPerson: true,
  },
});

// mutations
const mutations = {
  setCenterPersonModel(state, data) {
    state.centerPersonModel = data;
  },
};

// actions
const actions = {
  async loadCenterPersonList(vuexContext, co) {
    return await getCenterPersonList(co).then((response) => {
      let data = response.data.data;
      let items = data.items;
      let totalCount = data.totalCount;
      let totalPages = data.totalPages;
      items.map((s, index) => {
        s.index = index + 1;
        s.fullname = s.user.firstName + " " + s.user.lastName;

        if (s.classList && s.classList.length > 0)
          s.classList.map((sc, index) => {
            sc.index = index + 1;
          });

        if (s.operationClaims && s.operationClaims.length > 0) {
          s.operationClaimName = s.operationClaims.map(c => c.name).join(", ");
        }
      });
      setPaginationDetails(co, totalCount, totalPages);
      return items;
    });
  },

  async loadCenterPersonTypeList(vuexContext, co) {
    return await getCenterPersonTypeList(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async loadCenterPersonDistinctionList(vuexContext, co) {
    return await getCenterPersonDistinctionList(co).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
  async loadUserListNotTeacher(vuexContext, data) {
    return await getUserListNotTeacher(data).then((response) => {
      let data = response.data.data;

      data.map((item, index) => {
        item.index = index + 1;
        item.label = item.firstName + " " + item.lastName;
        item.value = item.id;
      });

      return data;
    });
  },

  async addCenterPerson(vuexContext, data) {
    return await addCenterPerson(data, data.rolId).then((response) => {
      let data = response.data;
      return data;
    });
  },

  async postNewCenterPerson(vuexContext, data) {
    return await postNewCenterPerson(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async updateCenterPerson(vuexContext, data) {
    return await updateCenterPerson(data, data.appOperationClaimId, data.rolId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async deleteCenterPerson(vuexContext, data) {
    return await deleteCenterPerson(data).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  addCenterPersonModel(vuexContext, data) {
    vuexContext.commit("setCenterPersonModel", data);
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
